import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { LanguageService } from '../services/language.service';
import { ShareTooltipService } from '../services/share-tooltip.service';

@Directive({
  selector: '[appTooltip]'
})
export class TooltipDirective {

  @Input('appTooltip') slug: string;
  @Input() shareType: any;

  constructor(private elementRef: ElementRef,
              private languageService: LanguageService,
              private shareTooltipService: ShareTooltipService) { }

  @HostListener('click', ['$event']) onClick(event) {
    event.stopPropagation();
    this.showTooltip();
  }

  @HostListener('window:resize', ['$event']) onResize() {
    this.closeTooltip();
  }
  @HostListener('window:scroll', ['$event']) onScroll() {
    this.closeTooltip();
  }

  @HostListener('document:click', ['$event.target']) onClickOutside(targetElement: any) {
    const isClickedInside = this.elementRef.nativeElement.contains(targetElement);
    if (!isClickedInside) {
      this.closeTooltip();
    }
  }

  showTooltip() {
    const elementClientRect = this.elementRef.nativeElement.getBoundingClientRect();
    const left = elementClientRect.left - (window.innerWidth < 992 ? 240 : 220);
    const top = elementClientRect.top > 355 ? elementClientRect.top - 235 : elementClientRect.top + 60;
    let url;
    if (this.slug) {
      url = `${window.location.origin}${this.languageService.getCurrentLangWithSlash()}/${this.shareType.type}/${this.slug}`;
    } else {
      url = `${window.location.origin}${this.languageService.getCurrentLangWithSlash()}/`;
    }

    this.shareTooltipService.showShareTooltip(top, left, url);
  }

  closeTooltip() {
    this.shareTooltipService.closeShareTooltip();
  }
}
